<template>
    <div class="order-details" id="subOutputRank-print">
		<div class="order-details-in">
            <div class="left">
                
                <div class="main">
                    <div class="customer-pd">
                        <div class="print-btn" @click="printBtn" v-if="!isPrint">
                            <i class="iconfont icon-print"></i> {{isZh?'打印入住单':'Print'}}
                        </div>
                        <div class="print-title">
                        	{{isZh?'酒店入住单':'Hotel voucher'}}
                        </div>
                        <div class="header-r" style="margin-right: 40px;" v-if="!isPrint">
                            <div class="language" @mouseover="languageShow=true" @mouseout="languageShow=false">
                                <div class="country" v-if="isZh"></div>
                                <div class="country-en" v-if="!isZh"></div>
                                <div class="text" :style="isZh?'font-size: 14px;margin-right: 14px;':'font-size: 14px;'">{{isZh?'简体中文':'English'}}
                                    <ul v-show="languageShow">
                                        <li @click="isZh=true;languageShow=false"><span class="one"></span>简体中文</li>
                                        <li @click="isZh=false;languageShow=false"><span class="two"></span>English</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-content">
                            <p class="info-value">
                                <span class="info-name" style="width: 200px;">
                                   {{isZh?'代理订单号':'Booking Ref'}}
                                </span>
                                <span>{{OrderDetailsList.OrderNO}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name" style="width: 200px;">
                                   {{isZh?'确认号':'Confirm number'}}
                                </span>
                                <span class="info-text" v-for="(i,index) in OrderDetailsList.ConfirmNOs">{{i||isZh?'暂无':'Nothing'}}{{i?(OrderDetailsList.ConfirmNOs.length-1-index>0?',':''):''}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name" style="width: 200px;">
                                    {{isZh?'下单时间':'Order time'}}
                                </span>
                                <span v-if="isZh">{{OrderDetailsList.BookingOn|dateLong}}</span>
                                <span v-if="!isZh">{{OrderDetailsList.BookingOn|dateEn}} {{OrderDetailsList.BookingOn|dateHMS}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="info-row">
                        <p class="info-label">{{isZh?'订单详情':'Order information'}}<label v-if="OrderDetailsList&&OrderDetailsList.Guest.length>0&&OrderDetailsList.Guest[0].CardNumber" @click="isLayerShow" style="color:#1270f8; padding-left: 10px;">为提升您的入园体验，请点击链接进行“人证合一”激活</label></p>
                        <div class="info-content">
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'酒店名称':'Hotel name'}}
                                </span>
                                <span class="info-text">{{isZh?OrderDetailsList.HotelName:OrderDetailsList.HotelNameEn}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'房型名称':'Room type'}}
                                </span>
                                <span class="info-text">{{isZh?OrderDetailsList.RoomName:OrderDetailsList.RoomNameEn}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'产品政策':'Product policy'}}
                                </span>
                                <span class="info-text">{{isZh?OrderDetailsList.RPName:OrderDetailsList.RPNameEn}}</span>
                            </p>
                            <p class="info-value" v-if="OrderDetailsList.SeasonCode">
                                <span class="info-name">
                                    {{isZh?'马戏场次':'Circus show'}}
                                </span>
                                <span>{{OrderDetailsList.SeasonCode|ChimelongStr}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'间夜数':'Room nights'}}
                                </span>
                                <span>{{OrderDetailsList.RoomCount}}{{isZh?'间':'Room'}} | {{OrderDetailsList.NightCount}}{{isZh?'夜':'nights'}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'入住时间':'Check in'}}
                                </span>
                                <span v-if="isZh">{{OrderDetailsList.CheckInStr|dateToYMDline}}</span>
                                <span v-if="!isZh">{{OrderDetailsList.CheckInStr|dateEn}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'离店时间':'Check out'}}
                                </span>
                                <span v-if="isZh">{{OrderDetailsList.CheckOutStr|dateToYMDline}}</span>
                                <span v-if="!isZh">{{OrderDetailsList.CheckOutStr|dateEn}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'特殊要求':'Special requirements'}}
                                </span>
                                <span class="info-text">{{OrderDetailsList.Remark!=''?OrderDetailsList.Remark:isZh?'暂无':'Nothing'}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                    {{isZh?'取消条款':'Cancellation Due'}}
                                </span>
                                <span v-if="!IsCancel" style="color: #f63;">{{isZh?'订单不可取消或更改':'It cannot be canceled or modified'}}</span>
                                <span v-if="IsCancel&&isZh">最晚取消时间：{{OrderDetailsList.CancelDate|dateLong}}</span>
                                <span v-if="IsCancel&&!isZh">Latest Cancellation Time：{{OrderDetailsList.CancelDate|dateEn}} {{OrderDetailsList.CancelDate|dateHMS}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="info-row">
                        <p class="info-label">{{isZh?'入住信息':'Guest information'}}</p>
                        <div class="info-content">
                            <p class="info-value">
                                <span class="info-name">
                                   {{isZh?'入住人':'Guest Name'}}
                                </span>
                                <span class="info-text">
                                    <span v-for="(item,index) in OrderDetailsList.Guest">{{item.FirstName}}{{item.LastName}} <span v-if="item.CardNumber">( {{item.CardNumber}} )</span> {{OrderDetailsList.Guest.length-1==index?'':'、'}}</span>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="info-row">
                        <p class="info-label">{{isZh?'酒店信息':'Hotel information'}}</p>
                        <div class="info-content">
                            <p class="info-value">
                                <span class="info-name">
                                   {{isZh?'酒店电话':'Hotel Tel'}}
                                </span>
                                <span>{{OrderDetailsList.HotelPhone||''}}</span>
                            </p>
                            <p class="info-value">
                                <span class="info-name">
                                   {{isZh?'酒店地址':'Hotel Address'}}
                                </span>
                                <span class="info-text">{{isZh?OrderDetailsList.HotelAddress:OrderDetailsList.HotelAddressEn||''}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="info-row">
                        <p class="info-label">{{isZh?'注意':'Tips'}}</p>
                        <div class="info-content">
                            <p class="info-value">
                                <div style="font-weight: bold;">{{isZh?'酒店问题':'Hotel problem'}}</div>
                                <span>{{isZh?'如果在到达酒店时没有找到预定或无法安排相应的房间，请您立即联系您下单的旅行社。如果您决定在不通知旅行社的情况下办理入住手续，那意味着您自愿放弃了赔偿权利。':'If you do not find a reservation or cannot arrange a room when you arrive at the hotel, please contact the travel agent you placed your order with immediately. If you decide to check in without informing the travel agent, you have voluntarily waived your right to compensation.'}}</span>
                                <div style="font-weight: bold;">{{isZh?'预定未入住或延迟入住':'Scheduled no-show or late check-in'}}</div>
                				<span>{{isZh?'如预定未入住或延迟入住，请提前通知酒店或旅行社。否则，酒店可能会在不联系或不通知客人的情况下解除预订，并自愿放弃赔偿权利。房费全额收费。':'In case of no-show or late check-in, please inform the hotel or travel agent in advance. Otherwise, the hotel may cancel the reservation without contacting or notifying the guest and voluntarily waive the right to compensation. The room is charged in full.'}}</span>
                                <div style="font-weight: bold;">{{isZh?'其它信息':'other information'}}</div>
                		        <span>{{isZh?'延期或修改的费用由客人按照现场价格支付。此预订不可改期转让，不可兑换现金。':'Any extension or modification will be paid by the guest at the on-site rate. This booking is non-transferable and not redeemable for cash.'}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="info-row">
                        <p class="info-label">{{isZh?'致酒店前台':'To the hotel front desk'}}</p>
                        <div class="info-content">
                            <p class="info-value">
                                <span>{{isZh?'本次预订贵酒店已确认，如果找不到该预订，请先与贵酒店预订部门核对确认号，并随时与我们联系。':'This reservation has been confirmed by your hotel. If you cannot find the reservation, please check the confirmation number with your hotel reservation department and contact us at any time.'}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Modal from './../../common/cmpnt/Modal/modal'

    export default {
        name: "order-Details",
        components:{
            Loading,
            Modal
        },
        data: function () {
            return {
                isLoading:false,
                OrderDetailsList:'',
                isPrint:false,
                userInfo: this.dao.get('userInfo'),
                PrintDate:new Date(),
                roomTotalAmount:0,
                RoomPrice:0,
                SurchargesPrice:0,
                SurchargesShow:false,
                qr:'',
                modal:{
                    show:false,
                    config:{}
                },
                cancelToken:'',
                isZh:true,
                languageShow:false,
                IsCancel:false
            }
        },
        created: function () {

        },
        mounted() {
            document.title='【'+(this.$route.params.orderNO)+'】'+'订单详情';
            this.initData();
            // this.getQR()
            this.printDate();
        },
        methods: {
            cancel(){
                var that = this;
                that.modal.show = false;
                that.isLoading = true;
                that.postRequest({
                    url: that.Api.cancelOrder,
                    params: that.cancelToken
                }).then(res => {
                    if (res.IsSuccess) {
                        that.initData()
                    } else {
                        that.error({title: '提示', content: res.Msg || '取消失败'});
                    }
                });
            },
            getQR(){
                var that = this;
                that.getRequest({
                    url: that.Api.qr+'?orderNO='+that.$route.params.orderNO,
                    params: ''
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.qr = 'data:image/jpg;base64,'+ res.Result
                    } else {
                        // $state.complete();
                    }
                });
            },
            jSurchargesPrice(list){
                if (list.length==0){
                    return
                }
                var z = 0;
                for (let i = 0; i<list.length; i++){
                    z += parseInt(list[i].Price)*parseInt(list[i].Num)
                }
                this.SurchargesPrice = z
            },
            jRoomPrice(list){
                if (list.length==0){
                    return
                }
                var z = 0;
                for (let i = 0; i < list.length; i++){
                    z += parseInt(list[i].Price)
                }
                this.RoomPrice = z;
            },
            printDate(){
                var that = this;
                var i = setInterval(function () {
                    that.PrintDate = new Date()
                },1000)
            },
            routerBookComfirm(orderNO){
                var that = this;
                var obj={
                    From:1,
                    HotelName:that.OrderDetailsList.HotelName,
                    RoomName:that.OrderDetailsList.RoomName,
                    RPName:'',
                    CheckIn:that.OrderDetailsList.CheckIn,
                    CheckOut:that.OrderDetailsList.CheckOut,
                    RoomCount:that.OrderDetailsList.RoomCount,
                    AdultCount:'',
                    Star:'',
                    HotelAddress:'',
                    HotelPhone:'',
                    AdultPrice:that.OrderDetailsList.TotalAmount,
                    days:that.OrderDetailsList.NightCount,
                    Token:'',
                    CancelPolicy:'',
                    Breakfast:'',
                    Currency:'',
                    Tip:'',
                    Stock:'',
                    MaxPerson:'',
                    Breakfast:'',
                    DailyRates:'',
                    IsAskRoom:'',
                    details:'',
                    room:''
                    
                }
                if(this.OrderDetailsList.OrderType==3){

                    
                    that.$router.push('/ticketBookComfirm?OrderNO='+orderNO)
                }else{
                    that.dao.set('bookInfo',obj);
                    that.$router.push('/bookComfirm?OrderNO='+orderNO)
                }
                
            },
            cancelOrder(token){
                if(!token){
                    return
                }
                var that = this;
                var params = {
                    Token:token
                }
                that.cancelToken = params
                that.modal={
                    show:true,
                    content:'确定要取消订单号:"' + that.$route.params.orderNO + '"的订单吗?',
                    yes:'确定',
                    no:'取消',
                    isComfirm:true
                }
            },
            printBtn(){
                this.isPoint = true;
                document.getElementsByClassName('print-btn')[0].style.display = 'none'
                let subOutputRankPrint = document.getElementById('subOutputRank-print');
                let newContent =subOutputRankPrint.innerHTML;
                let oldContent = document.body.innerHTML;
                document.body.innerHTML = newContent;
                window.print();
                window.location.reload();
                document.body.innerHTML = oldContent;
                document.getElementsByClassName('print-btn')[0].style.display = 'block'
                this.isPoint = false;
                return false;
            },
            // 是否为可取消订单
            getIsCancel(s1, s2) {
                s1 = new Date(s1);
                s2 = new Date(s2);
                var time = parseInt((s2-s1) / (1000 * 60));
                if(time>=0){
                    this.IsCancel=false
                }else{
                    this.IsCancel=true
                }
            },
            initData(){
                var that = this;
                that.isLoading = true;
                that.getRequest({
                    url: that.Api.getOrderDetails+'?orderNO='+that.$route.params.orderNO,
                    params: ''
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.OrderDetailsList = res.Result
                        that.OrderDetailsList.TotalAmount = that.OrderDetailsList.TotalAmount.toFixed(2);
                        that.getIsCancel(that.OrderDetailsList.CancelDate,that.OrderDetailsList.BookingOn)
                        // $state.loaded();
                        if(that.OrderDetailsList.Surcharges.length>0){
                            that.SurchargesShow = true
                        }
                        that.jSurchargesPrice(that.OrderDetailsList.Surcharges);
                        that.jRoomPrice(that.OrderDetailsList.Details);
                        that.getRoomTotalAmount();//房价小计
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }         
                        })
                    } else {
                        // $state.complete();
                    }
                });
            },
            //房价小计
            getRoomTotalAmount(){
                var list=this.OrderDetailsList.Details;
                var total=0;

                list.forEach((item)=>{
                  
                    total+=(item.Price*item.RoomCount)
                })
                this.roomTotalAmount=total;

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/order/Customer.vue